// Libs
import { createContext } from "react";
// Hooks
import { useLanguageHook, 
    // useLoaderHook 
} from "../hooks";
// Enums
import {
    ENUM_LANGUAGES
} from "../enums";
// Types
type TAppContextProviderProps = {
    children: React.ReactNode
}

type AppContextValue = {
    appText: any;
    langForText: any;
    setLangForText: (lang: any) => void;
  };

// Create initial empty context
const AppContext = createContext<AppContextValue>({
        appText: "",
        langForText: "",
        setLangForText: () => {return true}
});

const langaugesDropdownOptionsArr = [
    {
        label: "Italiano",
        value: ENUM_LANGUAGES.IT
    }, {
        label: "English",
        value: ENUM_LANGUAGES.EN
    }
];

/**
 * Main app context
 * @param {*} props
 * @returns
 */
const AppContextProvider = ({ children }: TAppContextProviderProps) => {
    const [appText, langForText, setLangForText] = useLanguageHook();

    return (
        <>
            <AppContext.Provider value={{
                appText: appText,
                langForText: langForText,
                setLangForText: setLangForText
            }}>
                {children}
            </AppContext.Provider>
        </>
    );
};

export default AppContextProvider;
export { AppContext, langaugesDropdownOptionsArr };
